import React, { useContext } from 'react'
import { IProps as ISelect, Select } from 'marketing-site/src/library/elements/Select'
import { CareersPageContext } from 'marketing-site/lib/page-behaviors/CareersPage'

export function LocationSelect(props: ISelect) {
  const { onLocationChange } = useContext(CareersPageContext)

  return <Select {...props} onChange={onLocationChange} />
}
